import { Button as ButtonMaterial } from "@mui/material";
import CustomTextField from "components/CustomTextField";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Row,
  Label,
  FormGroup,
} from "reactstrap";
import { useUpdateFarmerByIdMutation } from "./farmerApiSlice";

import {
  faFloppyDisk,
  faPenToSquare,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tag } from "antd";
import CardSkeleton from "components/CardSkeleton";
import swal from "sweetalert";
import { PinCodeComponent } from "components/PinCodeComponent";
import StateDistrict from "./StateDistrict";
const FarmerDetailsBasic = ({ data, refetch, isLoading }) => {
  const { id } = useParams();
  // const location = useLocation();
  // const { id,fullName } = location.state;

  const [updateFarmer] = useUpdateFarmerByIdMutation();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [occupationDropdown, dropdownDataOccupation] = useState([
    "Agriculture",
    "Trader",
    "Public Sector",
    "Private Sector",
    "Dairy Farmer",
    "Other",
  ]);

  const [categoryDropdown, dropdownDataCategory] = useState([
    "Marginal (Less than 2.5 acres)",
    "Small (2.5–5 acres)",
    "Semi Medium (5–10 acres)",
    "Medium (10–25 acres)",
    "Large (25 acres and above)",
  ]);
  const [user, setUser] = useState({
    id: "",
    created_at: "",
    first_name: "",
    last_name: "",
    full_name: "",
    state_code: "",
    DOB: "",
    age: "",
    gender: "",
    email: "",
    phone_number: "",
    farmer_category: "",
    alternate_phone_number: "",
    state_name: "",
    district_name: "",
    block_name: "",
    pincode: "",
    address: "",
  });
  // const {
  //   data: data,refetch
  // } = useGetFarmerByIdQuery(id)
  const [edit, setEdit] = useState(false);
  const [disableButton, disableSubmitBtn] = useState(false);
  const [backupData, setBackUpClearData] = useState([]);
  const [state_id, setStateId] = useState("");
  const [district_id, setDistrictId] = useState("");
  const [block_id, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [blockList, setBlockList] = useState([]);
  const [detail_type, setAddressBased] = useState("Pincode");
  useEffect(() => {
    setStateId(data?.data?.state_code);
    setDistrictId(data?.data?.district_code);
    setBlockId(data?.data?.block_code);
    setStateName(data?.data?.state_name);
    setDistrictName(data?.data?.district_name);
    setBlockName(data?.data?.block_name);
    setUser(data?.data);
    setBackUpClearData(data?.data);
  }, [data]);

  const handleEdit = () => {
    setEdit(true);
  };
  const handleClear = () => {
    setEdit(false);
    setUser(backupData);
    // setStateName(backupData.state_name);
    // setDistrictName(backupData.district_name);
    // setBlockName(backupData.block_name);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    swal("PLease Wait....", {
      buttons: false,
      showSpinner: true,
      title: "Loading...",
      timer: 2500,
    });
    disableSubmitBtn(true);
    let checkData = {
      id: user.id,
      created_at: user.created_at,
      first_name: user.first_name,
      last_name: user.last_name,
      full_name: user.full_name,
      phone_number: user.phone_number,
      farmer_category: user.farmer_category,
      alternate_phone_number: user.alternate_phone_number,
      DOB:
        user?.DOB?.split("-")[0].length == 4
          ? user?.DOB?.split("-")
              .reverse()
              .join("-")
          : user?.DOB,
      age: user.age,
      gender: user.gender,
      email: user.email,
      pincode: user.pincode,
      address: user.address,
      secondary_occupation: user.secondary_occupation,
      interested_services: user.interested_services,
    };

    if (detail_type !== "Pincode") {
      checkData = {
        ...checkData,
        state_name: stateName,
        state_code: state_id,
        district_name: districtName,
        district_code: district_id,
        block_code: block_id,
        block_name: blockName,
        pincode: "",
      };
    }

    updateFarmer({ id: checkData.id, payload: checkData })
      .unwrap()
      .then((data) => {
        disableSubmitBtn(false);
        setLoading(false);
        swal("Farmer updated Successfully", {
          buttons: false,
          icon: "success",
          title: "Successfully Updated Farmer",
          timer: 1500,
        });

        setEdit(false);
        refetch();
      })
      .catch((error) => {
        disableSubmitBtn(false);

        swal("Error", {
          buttons: false,
          icon: "error",
          title: "Error Updating Farmer",
          timer: 1500,
        });
        return;
      });
  };

  const onInputChange = (event) => {
    console.log(event.target.value, "---", event.target.name);
    setUser({
      ...user,
      [event.target.name]: event.target.value,
    });
  };

  const [selectedServices, setSelectedServices] = useState([]);
  const options = ["Loan", "Insurance", "Advisory", "Sell Produce"];

  useEffect(() => {
    if (user?.interested_services) {
      setSelectedServices(
        user.interested_services.split(", ").map((s) => s.trim())
      );
    }
  }, [user?.interested_services]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedServices = [...selectedServices];

    if (checked) {
      updatedServices.push(value);
    } else {
      updatedServices = updatedServices.filter((service) => service !== value);
    }

    setSelectedServices(updatedServices);

    const formattedString = updatedServices.join(", ");

    onInputChange({
      target: { name: "interested_services", value: formattedString },
    });
  };
  const onLocationChange = (event) => {
    if (event.ConditionName == "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName == "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };

  return (
    <>
      <div className="mt-1 transparent_card">
        <div className="d-lg-block d-md-none d-none">
          <div
            className="d-flex justify-content-end headerStyleCard"
            style={{ borderRadius: "5px", backgroundColor: "#f1f1f1" }}
          >
            {edit ? (
              <>
                <ButtonMaterial
                  variant="contained"
                  color="success"
                  className={` me-2  mt-1`}
                  onClick={handleSubmit}
                  disabled={disableButton ? true : false}
                  size="sm"
                >
                  Submit &nbsp;
                  <FontAwesomeIcon icon={faFloppyDisk} />
                </ButtonMaterial>
                <ButtonMaterial
                  variant="contained"
                  color="error"
                  className={` me-2  mt-1`}
                  onClick={handleClear}
                  size="sm"
                >
                  Cancel &nbsp;
                  <FontAwesomeIcon icon={faXmark} />
                </ButtonMaterial>
              </>
            ) : (
              <ButtonMaterial
                variant="contained"
                className={`buttonOrangeDefaultColor me-2  mt-1`}
                onClick={handleEdit}
                size="sm"
              >
                Edit &nbsp;
                <FontAwesomeIcon icon={faPenToSquare} />
              </ButtonMaterial>
            )}
          </div>
        </div>
        <Card className="">
          <CardBody className="p-2 p-lg-3">
            <div className="d-lg-block d-md-none d-none">
              <Row className="text-gray ">
                <Col lg="2" md="3" xs="6" className="d-none d-lg-block">
                  <div
                    className="rounded-3 mt-1"
                    style={{
                      border: "1px solid lightgrey ",
                      borderStyle: "dashed",
                    }}
                  >
                    <div style={{ padding: "1.8rem" }}>
                      <div className="text-center">
                        <img
                          src={user?.profile_pic}
                          height="100px"
                          width="100px"
                          style={{ borderRadius: "50%", objectFit: "cover" }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg="3" md="3" xs="12" className="mb-2 ">
                  <Row>
                    <Col lg="12">
                      <CustomTextField
                        type="text"
                        name="first_name"
                        value={user?.first_name}
                        disabled={edit ? false : true}
                        onChange={onInputChange}
                      />
                    </Col>
                    <Col className="mt-3">
                      <CustomTextField
                        type="text"
                        name="phone_number"
                        defaultValue={user?.phone_number}
                        disabled
                        onChange={onInputChange}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg="3" md="3" xs="12" className="mb-2">
                  <Row>
                    <Col lg="12">
                      <CustomTextField
                        type="text"
                        name="last_name"
                        value={user?.last_name}
                        disabled={edit ? false : true}
                        onChange={onInputChange}
                      />
                    </Col>

                    <Col lg="12" className="mb-3 mt-3">
                      <CustomTextField
                        type="select"
                        name="farmer_category"
                        required
                        onChange={onInputChange}
                        className="text-gray"
                        style={{ padding: "8px" }}
                        value={user?.farmer_category}
                        disabled={edit ? false : true}
                      >
                        <option value="">Select</option>
                        {categoryDropdown?.map((item, id) => {
                          return (
                            <option value={item} key={id}>
                              {item}
                            </option>
                          );
                        })}
                      </CustomTextField>
                    </Col>
                  </Row>
                </Col>

                <Col lg="4" md="3" xs="12" className="mb-2">
                  <Row>
                    <Col lg="7" md="7" xs="12" className="">
                      {edit ? (
                        <CustomTextField
                          type="date"
                          name="DOB"
                          defaultValue={user?.DOB}
                          disabled={edit ? false : true}
                          onChange={onInputChange}
                        />
                      ) : (
                        <CustomTextField
                          type="text"
                          name="DOB"
                          disabled={true}
                          value={user?.DOB}
                          onChange={onInputChange}
                        />
                      )}
                    </Col>
                    <Col lg="5" md="5" xs="12" className="">
                      <CustomTextField
                        type="text"
                        name="age"
                        defaultValue={user?.age}
                        disabled
                        onChange={onInputChange}
                      />
                    </Col>
                    <Row>
                      <Col lg="7" md="7" xs="12" className="mb-2 mt-3">
                        <CustomTextField
                          type="text"
                          name="email"
                          value={user?.email}
                          disabled={edit ? false : true}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col lg="5" md="5" xs="12" className="mt-3">
                        {edit ? (
                          <div>
                            <label className="mx-2 fw-bold">Gender</label>
                            <Input
                              type="select"
                              className="form-control mt-2 mx-2 rounded-1"
                              name="gender"
                              value={user?.gender}
                              defaultValue={user?.gender}
                              style={{ padding: "8px", borderRadius: "0rem" }}
                              disabled={edit ? false : true}
                              onChange={onInputChange}
                            >
                              <option value="select">Select </option>
                              <option id="" value="Male">
                                Male
                              </option>
                              <option id="" value="female">
                                Female
                              </option>
                            </Input>
                          </div>
                        ) : (
                          <Col className="mx-2" lg="12">
                            <CustomTextField
                              type="text"
                              name="gender"
                              value={user?.gender}
                              disabled={edit ? false : true}
                              onChange={onInputChange}
                            />
                          </Col>
                        )}
                      </Col>
                    </Row>
                  </Row>
                </Col>
                <Col lg="2" md="3" xs="3" className="mb-2 mt-2">
                  <CustomTextField
                    type="text"
                    name="primary_occupation"
                    value={user?.primary_occupation}
                    disabled
                    onChange={onInputChange}
                  />
                </Col>
                <Col lg="3" md="3" xs="3" className="mb-2 mt-2">
                  <CustomTextField
                    type="select"
                    name="secondary_occupation"
                    className="text-gray"
                    value={user?.secondary_occupation}
                    disabled={edit ? false : true}
                    onChange={onInputChange}
                    style={{ padding: "8px" }}
                  >
                    <option value="">Select</option>
                    {occupationDropdown?.map((item, id) => {
                      return (
                        <option value={item} key={id}>
                          {item}
                        </option>
                      );
                    })}
                  </CustomTextField>
                </Col>
                <Col lg="4" md="5" xs="5" className="mb-2 mt-2">
                  {edit ? (
                    <div>
                      <Label className="mb-1">Interested Services</Label>
                      <FormGroup className="d-flex flex-wrap">
                        {options.map((option) => (
                          <div
                            key={option}
                            className="me-3 d-flex align-items-center"
                          >
                            <Input
                              type="checkbox"
                              value={option}
                              name="interested_services"
                              checked={selectedServices.includes(option)}
                              onChange={handleCheckboxChange}
                            />
                            <Label className="ms-1 mt-3 mx-2">{option}</Label>
                          </div>
                        ))}
                      </FormGroup>
                    </div>
                  ) : (
                    <CustomTextField
                      type="text"
                      name="interested_services"
                      value={user?.interested_services || ""}
                      disabled
                      onChange={onInputChange}
                    />
                  )}
                </Col>

                {edit ? (
                  <Col lg="5">
                    <label>
                      <b>Add Details Based on</b>
                    </label>
                    <FormGroup className="mt-2">
                      <div className="d-flex flex-row">
                        <Label className="d-flex align-items-center">
                          <Input
                            type="radio"
                            name="Pincode"
                            value="Pincode"
                            checked={detail_type === "Pincode"}
                            onChange={(e) => setAddressBased(e.target.value)}
                          />
                          <span className="ms-2 mt-1">Pincode</span>
                        </Label>
                        <Label className="d-flex align-items-center mt-1 mx-5">
                          <Input
                            type="radio"
                            name="SDB"
                            value="SDB"
                            checked={detail_type === "SDB"}
                            onChange={(e) => setAddressBased(e.target.value)}
                          />
                          <span className="ms-2 mt-1">
                            Based on State, District, Block
                          </span>
                        </Label>
                      </div>
                    </FormGroup>
                  </Col>
                ) : (
                  <Col lg="3" className="mb-3">
                    <CustomTextField
                      type="text"
                      name="pincode"
                      value={user?.pincode}
                      onChange={onInputChange}
                      disabled={edit ? false : true}
                      maxLength="6"
                      className="mt-2"
                    />
                  </Col>
                )}

                {edit && detail_type === "Pincode" ? (
                  <Row>
                    <Col lg="2">
                      <CustomTextField
                        type="text"
                        name="pincode"
                        value={user?.pincode}
                        onChange={onInputChange}
                        disabled={edit ? false : true}
                        maxLength="6"
                        className=""
                      />
                    </Col>
                    <PinCodeComponent pincode={user?.pincode} />
                  </Row>
                ) : edit && detail_type === "SDB" ? (
                  <StateDistrict
                    onLocationChange={onLocationChange}
                    state_id={state_id}
                    district_id={district_id}
                    block_id={block_id}
                    stateName={stateName}
                    districtName={districtName}
                    blockName={blockName}
                    setBlockList={setBlockList}
                    blockList={blockList}
                  />
                ) : (
                  ""
                )}
              </Row>
            </div>

            {isLoading ? (
              <CardSkeleton />
            ) : (
              <div className="card  col-lg-3 col-md-6 col-12 shadow-sm rounded-3  d-lg-none d-md-block d-block">
                <div className="card-body p-3 fpo_card position-relative">
                  <div
                    className="d-flex align-items-center py-2 gap-3"
                    style={{ borderBottom: "1px solid #ebeaeab5" }}
                  >
                    <img
                      src={user?.profile_pic}
                      style={{
                        height: "50px",
                        width: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />

                    <div>
                      <h5 className="text-success m-0 text-capitalize">
                        {user?.full_name || "N/A"}
                      </h5>
                      <div className="d-flex ">
                        <h6
                          style={{
                            color: "#5c5c5cb3",
                          }}
                        >
                          {user?.primary_occupation}
                        </h6>
                      </div>
                    </div>
                    <i
                      className="mdi mdi-pencil text-primary position-absolute  fs-4 cursor-pointer"
                      style={{ right: "4%", top: "10%" }}
                      onClick={() => setShowModal(true)}
                    ></i>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <span className="card-text d-flex gap-1 mt-1">
                      <i className="mdi mdi-phone text-warning me-2 fs-6"></i>
                      <h6>Phone:</h6> {user?.phone_number || "N/A"}
                    </span>

                    <span className="card-text d-flex gap-1 mt-1">
                      <i className="mdi mdi-calendar-clock text-secondary me-2 fs-6"></i>
                      <h6>DOB:</h6> {user?.DOB || "N/A"}
                    </span>
                  </div>

                  <span className="card-text d-flex gap-1 mt-2">
                    <i className="mdi mdi-map-marker text-danger me-2 fs-6"></i>
                    {user?.address || "N/A"}
                  </span>
                  <span className="card-text d-flex gap-1 mt-2">
                    <i className="mdi mdi-information text-success me-2 fs-6"></i>
                    <h6>Status:</h6>{" "}
                    <Tag
                      bordered={false}
                      style={{ fontWeight: "500" }}
                      color="geekblue"
                    >
                      {user?.current_status?.replaceAll("_", " ").slice(0, 30)}
                      {user?.current_status?.length > 30 ? "..." : ""}
                    </Tag>
                  </span>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="xl"
          centered={true}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "" }} className="fw-bold">
              Edit Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3">
            <Row className="text-gray">
              <Col lg="3" md="3" xs="6" className="mb-2 d-none d-lg-block">
                <Card style={{ border: "1px solid lightgrey" }}>
                  <CardBody style={{ padding: "2rem" }}>
                    <div className="text-center">
                      <img src={user?.profile_pic} height="120px" />
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="3" md="3" xs="12" className="mb-2 ">
                <Row>
                  <Col xs="6">
                    <CustomTextField
                      type="text"
                      name="first_name"
                      value={user?.first_name}
                      onChange={onInputChange}
                    />
                  </Col>
                  <Col xs="6">
                    <CustomTextField
                      type="text"
                      name="last_name"
                      value={user?.last_name}
                      onChange={onInputChange}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg="3" md="3" xs="12" className="mb-2">
                <Row className="mt-1">
                  <Col>
                    <CustomTextField
                      type="text"
                      name="phone_number"
                      defaultValue={user?.phone_number}
                      disabled
                      onChange={onInputChange}
                    />
                  </Col>

                  <Col xs="6">
                    <CustomTextField
                      type="text"
                      name="alternate_phone_number"
                      label="alternate Phone No"
                      maxLength="10"
                      value={user?.alternate_phone_number}
                      onChange={onInputChange}
                    />
                  </Col>
                  <Col xs="6" className="mt-2">
                    <CustomTextField
                      type="date"
                      name="DOB"
                      defaultValue={user?.DOB}
                      onChange={onInputChange}
                    />
                  </Col>
                  <Col xs="6" className="mt-2">
                    <CustomTextField
                      type="text"
                      name="email"
                      value={user?.email}
                      onChange={onInputChange}
                    />
                  </Col>
                </Row>
              </Col>

              <Col lg="5" md="5" xs="6" className="">
                <CustomTextField
                  type="text"
                  name="age"
                  defaultValue={user?.age}
                  disabled
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="5" md="5" xs="6" className="">
                <label className="mx-2 font-weight-bold text-black">
                  Gender
                </label>
                <Input
                  type="select"
                  className="form-control mt-2 fs-6 mx-2"
                  name="gender"
                  value={user?.gender}
                  style={{ padding: "11px", borderRadius: "0rem" }}
                  onChange={onInputChange}
                >
                  <option value="select">Select </option>
                  <option id="" value="Male">
                    Male
                  </option>
                  <option id="" value="female">
                    Female
                  </option>
                </Input>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <ButtonMaterial
              variant="contained"
              color="success"
              className={` me-2  mt-1`}
              onClick={handleSubmit}
            >
              Submit &nbsp;
              <FontAwesomeIcon icon={faFloppyDisk} />
            </ButtonMaterial>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default FarmerDetailsBasic;
